<template>
  <div v-show="isShow" id="loading">
    <div class="loading-inner">
      <go-loading-b class="loading" :size="24"></go-loading-b>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>
<style lang="stylus" scoped>
#loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  // z-index: 1000000;
  z-index: 2000;
  background: rgba(255, 255, 255, 0.3);

  .loading-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    img {
      width: 30px;
    }
  }
}
</style>
